export const getFlightColor = (
  theme: { tokens: { color: { text: { primary: string; secondary: string; tertiary: string } } } },
  variant?: 'previous' | 'new',
  isFlown?: boolean
): string => {
  if (variant === 'new') return theme.tokens.color.text.tertiary;
  if (variant === 'previous' && isFlown) return theme.tokens.color.text.tertiary;
  return theme.tokens.color.text.secondary;
};

